import { render, staticRenderFns } from "./CoursewareUnitItemDialogLayout.vue?vue&type=template&id=20182867&"
import script from "./CoursewareUnitItemDialogLayout.vue?vue&type=script&lang=js&"
export * from "./CoursewareUnitItemDialogLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports